export interface Pagination {
  page: number;
  pageSize: number;
}

export const paginationToParams = (pagination: Pagination) => ({
  page: pagination.page + 1,
  'page-size': pagination.pageSize,
});
